import e, { forwardRef as m } from "react";
import { getComponent as a, getEnableFallbackComponent as p, getCustomFallbackComponent as c } from "./index2.mjs";
const u = m(
  ({ blok: t, ...o }, l) => {
    if (!t)
      return console.error(
        "Please provide a 'blok' property to the StoryblokComponent"
      ), /* @__PURE__ */ e.createElement("div", null, "Please provide a blok property to the StoryblokComponent");
    const n = a(t.component);
    if (n)
      return /* @__PURE__ */ e.createElement(n, { ref: l, blok: t, ...o });
    if (p()) {
      const r = c();
      return r ? /* @__PURE__ */ e.createElement(r, { blok: t, ...o }) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("p", null, "Component could not be found for blok", " ", /* @__PURE__ */ e.createElement("strong", null, t.component), "! Is it configured correctly?"));
    }
    return /* @__PURE__ */ e.createElement("div", null);
  }
);
u.displayName = "StoryblokComponent";
export {
  u as default
};
